"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddonStrings = useAddonStrings;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = require("react");

var _context = require("../context");

var _data = require("../data");

var _dec, _class, _descriptor, _temp;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AddonData = (_dec = (0, _data.column)('Text'), (_class = (_temp = /*#__PURE__*/function (_Data) {
  (0, _inherits2["default"])(AddonData, _Data);

  var _super = _createSuper(AddonData);

  function AddonData() {
    var _this;

    (0, _classCallCheck2["default"])(this, AddonData);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2["default"])(_this, "text", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  return AddonData;
}(_data.Data), _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "text", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));

function useAddonStrings(_ref) {
  var ids = _ref.ids,
      language = _ref.language;

  var _useContext = (0, _react.useContext)(_context.Context),
      defaultLanguage = _useContext.defaultLanguage,
      getCachedData = _useContext.getCachedData,
      requestGameData = _useContext.requestGameData;

  var resolvedLanguage = language !== null && language !== void 0 ? language : defaultLanguage; // Initialise the state from cache if possible, falling back to definition defaults

  var _useState = (0, _react.useState)(function () {
    var strings = {};

    for (var key in ids) {
      var _ref2, _data$text;

      var definition = ids[key];
      var data = getCachedData([AddonData, resolvedLanguage, 'Addon', definition.id]);
      strings[key] = (_ref2 = (_data$text = data === null || data === void 0 ? void 0 : data.text) !== null && _data$text !== void 0 ? _data$text : definition["default"]) !== null && _ref2 !== void 0 ? _ref2 : 'Loading';
    }

    return strings;
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      strings = _useState2[0],
      setStrings = _useState2[1]; // Fire off requests for all the strings


  (0, _react.useEffect)(function () {
    var promises = Object.keys(ids).map(function (key) {
      return requestGameData([AddonData, resolvedLanguage, 'Addon', ids[key].id]).then(function (data) {
        return {
          key: key,
          value: data === null || data === void 0 ? void 0 : data.text
        };
      });
    });
    Promise.all(promises).then(function (results) {
      setStrings(function (current) {
        var next = _objectSpread({}, current);

        var _iterator = _createForOfIteratorHelper(results),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var result = _step.value;

            if (result.value == null) {
              continue;
            }

            next[result.key] = result.value;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return next;
      });
    });
  }, [ids, requestGameData, resolvedLanguage]);
  return strings;
}